import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Biography from "./pages/Biography";
import Music from "./pages/Music";
import Links from "./pages/Links";
import Contact from "./pages/Contact";
import Pictures from "./pages/Pictures";
import Termine from "./pages/Termine";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/termine" element={<Termine />} />
          <Route path="/biographie" element={<Biography />} />
          <Route path="/bilder" element={<Pictures />} />
          <Route path="/musik" element={<Music />} />
          <Route path="/links" element={<Links />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;